import { Button as MUIButton, DialogTitle, DialogContent, DialogActions, Box, Alert, TextField } from '@mui/material';
import { useNotify, useRefresh, useTranslate } from 'react-admin';
import {
  createBatchDesignatedRedPackets,
  BatchDesignatedRedPacketInput,
} from '../../../services/redpacketService';
import { useState } from 'react';
import { PermissionButton } from '../../../../../routes/components/permission-button';

const CreateBatchDesignatedRedPacket = ({ onClose }: { onClose: () => void }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();
  const [csvText, setCsvText] = useState('');

  const handleSave = async () => {
    if (!csvText.trim()) {
      notify(t('module.redpacket.pleasePasteCsv'), { type: 'error' });
      return;
    }

    try {
      const lines = csvText.split('\n').filter((line) => line.trim());
      if (lines.length === 0) {
        notify(t('module.redpacket.pleasePasteOneLine'), { type: 'error' });
        return;
      }

      const inputs: BatchDesignatedRedPacketInput[] = lines.map((line) => {
        const parts = line.split(',').map((p) => p.trim());
        const walletAddress = parts[0] || '';
        const designatedAmount = parts[1] || '';
        return {
          walletAddress,
          designatedAmount,
          expiresAt: undefined, // 第三个字段不填，默认为 undefined
        };
      });

      // 验证数据
      const invalidItems = inputs.filter((item) => !item.walletAddress || !item.designatedAmount);
      if (invalidItems.length > 0) {
        notify(t('module.redpacket.ensureWalletAndAmount'), { type: 'error' });
        return;
      }

      const result = await createBatchDesignatedRedPackets(inputs);
      if (result.success) {
        notify(t('module.redpacket.batchCreateSuccess', { count: result.createdCount, amount: result.totalAmountReserved }), {
          type: 'success',
        });
        refresh();
        onClose();
      } else {
        notify(result.errorMessage || t('module.redpacket.batchCreationFailed'), { type: 'error' });
      }
    } catch (error: any) {
      notify(error.message || t('module.redpacket.batchCreationFailed'), { type: 'error' });
    }
  };

  return (
    <>
      <DialogTitle>{t('module.redpacket.batchCreateDesignated')}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, minWidth: 500 }}>
          <Alert severity="info" sx={{ mb: 2 }}>
            {t('module.redpacket.pasteCsvFormat')}
            <br />
            {t('module.redpacket.csvExample')}
          </Alert>
          <TextField
            multiline
            rows={10}
            fullWidth
            placeholder={`0xa5bce9ed345edd2bfc7cb031683c72694c097e56,20
0xa5bce9ed345edd2bfc7cb031683c72694c097e56,188`}
            value={csvText}
            onChange={(e) => setCsvText(e.target.value)}
            sx={{ fontFamily: 'monospace' }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <MUIButton variant="outlined" onClick={onClose}>
          {t('actions.cancel')}
        </MUIButton>
        <PermissionButton resource="redpacket" action="create">
          <MUIButton variant="contained" onClick={handleSave} disabled={!csvText.trim()}>
            {t('actions.save')}
          </MUIButton>
        </PermissionButton>
      </DialogActions>
    </>
  );
};

export default CreateBatchDesignatedRedPacket;
